import React, {useState, useEffect} from 'react'
import {LoadEffect}  from '../component/loader'
import axios from 'axios'
import { Alerts, WarningModal } from '../../component/notify'
import PageHeader from '../component/pageheader'
import { ServerUrl,  Token, config, schoolName, ImagesUrl, staffCode} from '../../component/include'
import { longDate } from '../component/globalFunction'


const DisplayStaffAttendance =()=> {
    const [result, setResult]= useState([])
    const [sqlQuery, setSqlQuery] = useState([]);
    const [schoolInfo, setSchoolInfo]=useState([])
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    }); 
    const [attendance, setAttendance] = useState({
        attendanceMonth:''
    })
   
    const [head, setHead]= useState([])


    const fetchSchoolInfo =()=>{
        const fd = new FormData();
            fd.append('jwt', Token);  
        let url = ServerUrl + '/fetch_controller/tbl_basic_details'
        axios.post(url, fd, config).then(result=>setSchoolInfo(result.data))

    }



    const handleChangeDate=(event)=>{
        const {name, value} = event.target;
        setAttendance({...attendance, attendanceMonth:value})
        const days =  new Date(value.slice(0,4), value.slice(5,7), 0).getDate();
        const start = value+'-01';
        const end = value+'-'+days;
        getDaysBetween(start, end)
        setResult('')
    }
   
    const getDaysBetween =(startDate, endDate)=>{
        const start = new Date(startDate)
        const end =  new Date(endDate)
    
        var result = []
        while (start <= end){
            result.push(new Date(start).toISOString().slice(0,10))
            start.setDate(start.getDate()+1)
        }

        let sqlString = result.map(data=>"max(case when a.attendanceDate  = '"+data+"'  then a.attendance else '-' end) AS '"+data.slice(8,10)+getDays(data)+"'")
        setHead(result.map(data=>data.slice(8,10)+getDays(data)))

        let final =   'SELECT s.staffName, sum(case when a.attendance  = "P" then 1 else 0 end) as P, sum(case when a.attendance  = "H" then 1 else 0 end) as H, sum(case when a.attendance  = "A" then 1 else 0 end) as A, '+String(sqlString)+ ' from tbl_staff s, tbl_staff_attendance a where s.code = a.staffCode and s.employmentStatus = "Working" and s.code ="'+staffCode+'" and a.attendanceDate >= "'+startDate+'" and a.attendanceDate <= "'+endDate+'" group by a.staffCode'
        setSqlQuery(final)
    }
    
    const getDays=(date)=>{
        let day;
        switch (new Date(date).getDay()){
            case 0:
                day =" Sun";
                break;
            case 1:
                day =" Mon";
                break;
            case 2:
                day =" Tue";
               break;
            case 3:
                day =" Wed";
                    break;
            case 4:
                day =" Thu";
                    break;
            case 5:
                day =" Fri";
                break;
            case 6:
                day =" Sat"
                break;
            default:
                day=" Sun"
        }
            return day
        }

        const fetchResult =()=>{
            if(attendance.attendanceMonth===''){
                Alerts('Error!', 'danger', 'Please select attendnace month')
            }else{

            
            setNotice({...notice, isLoading: true}) 

            const fd = new FormData();
            fd.append('jwt', Token);  
        fd.append("sql", sqlQuery);
        let url = ServerUrl+'/fetchBySql_controller'
        axios.post(url, fd, config).then(result=>{
            if(result.data.length!==0){
                setResult(result.data)
            }else{
                Alerts('Info!', 'default', 'No record found for the selected month')
            }
            
        })
        .catch((error)=>{
        Alerts('Error!', 'danger', error.message)
        }).finally(()=>{
            setNotice({...notice, isLoading: false})
            
        }) 
    }
        }




     useEffect(()=>{
        fetchSchoolInfo()
    },[]);


        return (  
            <React.Fragment>
   <>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Attendance">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-calendar"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Attendance</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Staff Attendance</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">

                <div className="row no-print ">
							
	<div className="col-sm-12">

    <div className="card z-depth-0">
		<div className="card-header">
			<h5><i className="fa fa-edit" ></i> Display Staff Attendance</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div>
        
        <div className="card-block">
            
        <section className="col-md-12">
        <span className="pcoded-badge label bg-simple-c-pink">Color Icon For Absent</span>
        <span className="pcoded-badge label label-info">Color Icon For Half Day</span>
        <span className="pcoded-badge label bg-simple-c-green">Color Icon For Present</span>
        </section>


        <div  className="card-block">
        <div  className="card z-depth-0" >

		<div  className="card-block">
		
        <div className="row">

        <section className="col-md-6">
   

               <div className="form-group">
   <label >Select Attendance Month</label>
   <input type="month" className='form-control' name="attendanceDate"  onChange={handleChangeDate} value={attendance.attendanceDate} />

               </div>
</section>	
<section className="col-md-6"><br/>
	<footer className="pull-left">
	<label></label>
	<button type="button" id="submit" onClick={()=>fetchResult()} className="btn btn-primary "><i className="fa fa-search"></i> Proceed</button>
								</footer>		</section>		
							</div>
                            
                            
                            </div></div> 
							</div></div>
</div>
</div>
</div>
	

{result.length!==0?
    <div className="card z-depth-0">
		<div className="card-block">
	
        {schoolInfo&&schoolInfo.map((st, id)=>
                       <div className="row" key={id}>

<table className="table  table-full-width">
       <tbody>
                <tr>
               {/*      <td className="pull-right" ><img id="viewSchoolLogo2" className="img-100" onError={(e)=>{e.target.onerror = null; e.target.src=ServerImagesUrl+'/logo.png'}} src={`${ServerImagesUrl}/about/${st.schoolLogo}`}  title="School Logo" alt=''  /></td>
                    <td >
<h4 style={{textAlign:'center'}}><b>{schoolName}</b></h4>
<div style={{textAlign:'center'}}>  {st.address}  </div>
<div style={{textAlign:'center'}}>  {st.mobile} &nbsp; {st.altMobile} </div>
 <div style={{textAlign:'center'}}>  {st.email} </div></td> */}

<td className="text-center" >
                    <img id="viewSchoolLogo2"  onError={(e)=>{e.target.onerror = null; e.target.src=ImagesUrl+'/logo.png'}} src={`${ImagesUrl}/about/headerlogo.png`}   alt={schoolName}  />
 </td>
                </tr>
            </tbody>
       </table>

</div> 
                       )}
 <div className="row">
        <div className="col-md-12">
        <h5 style={{textAlign:'center'}}><u><b>Staff Attendance </b></u></h5>
        </div></div><br/>



<div className="row">
<div className="col-md-12 table-responsive">

       <table className="table table-bordered  table-full-width">
       <tbody>
                <tr>
                    <td >Month: <b>{attendance.attendanceMonth}</b></td>
                    <td>Date Printed: <b>{longDate(new Date())} </b></td>
                </tr>
            </tbody>
       </table>
       <table className="table table-striped table-bordered">
        <thead>
                <tr>
                <th>S/N</th>
                    <th>Staff Name</th>
                    <th><span className="pcoded-badge label label-success">P</span></th>
                    <th><span className="pcoded-badge label label-info">H</span></th>            
                    <th><span className="pcoded-badge label label-danger">A</span></th>
                    {head&&head.map((data, id)=><th key={id} >{data}</th>)}
                </tr>
              </thead>
              <tbody>
              {result.length!==0?result.map((st, idx)=> 
                <tr key={idx}>
                <td>{idx+1}</td>
                <td>{st.staffName}</td>
                <td><span className="pcoded-badge label label-success">{st.P}</span></td>
                    <td><span className="pcoded-badge label label-info">{st.H}</span></td>            
                    <td><span className="pcoded-badge label label-danger">{st.A}</span></td>
                {head&&head.map((data, id)=><td key={id} >
                    {st[data]==='P'?
                    <span className="pcoded-badge label label-success">{st[data]}</span>:
                    st[data]==='A'?
                    <span className="pcoded-badge label label-danger">{st[data]}</span>:
                    st[data]==='H'?
                    <span className="pcoded-badge label label-info">{st[data]}</span>:
                    st[data]} </td>)} 
                </tr>):[]}
              </tbody>

        </table>
 </div>	 </div> 


 </div>
        </div>:''}



   </div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
</React.Fragment>
 );
        
}

export default React.memo(DisplayStaffAttendance) 